import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useAxios from '../../hooks/useAxios';
import { IGetRecentTuition } from '../../models/payments.model';
import { IGetGaDevice, IGetGaSite, IGetGaUser } from '../../models/ga.model';
import { getRecentTuition } from '../../api/payments.api';
import { getGaDevice, getGaSite, getGaUser } from '../../api/ga.api';
import { Col, Row } from 'antd';
import Section from './head-office/Section';
import ColumnChart from './head-office/ColumnChart';
import HomepageVisitChart from './head-office/HomepageVisitChart';
import Loader from '../Loader';
import ErrorResponse from '../ErrorResponse';
import HomepageDeviceChart from './head-office/HomepageDeviceChart';
import StudentChart from './head-office/StudentChart';
import CampusStatus from './head-office/CampusStatus';
import CampusSales from './head-office/CampusSales';
import { IGetCurrentSemester } from '../../models/semesters.model';
import { getCurrentSemester } from '../../api/semesters.api';
import PageStats from './head-office/PageStats';

const HeadOffice: FC = () => {
  const { t } = useTranslation();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetRecentTuition>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetRecentTuition>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetGaDevice>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetGaUser>();
  const {
    data: res5,
    isLoading: isLoading5,
    error: error5,
    execute: execute5,
  } = useAxios<IGetGaSite>();
  const {
    data: res6,
    isLoading: isLoading6,
    error: error6,
    execute: execute6,
  } = useAxios<IGetCurrentSemester>();

  useEffect(() => {
    execute(getRecentTuition('DR'));
    execute2(getRecentTuition('BR'));
    execute3(getGaDevice());
    execute4(getGaUser());
    execute5(getGaSite());
    execute6(getCurrentSemester());
  }, []);

  return (
    <div className="board-thirds mt-3">
      {(isLoading ||
        isLoading2 ||
        isLoading3 ||
        isLoading4 ||
        isLoading5 ||
        isLoading6) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={error5} />
      <ErrorResponse error={error6} />

      <div className='col-frame'>
        <Section title={t('class.dashboard.title2')}>
          <CampusStatus />
        </Section>
        <Section
          title={t('class.dashboard.title3')}
          path="/statistics/student-enroll"
        >
          <div className='board-chart-area donut-graph pt-5'>
            <StudentChart semesterCode={res6?.data?.semesterCode} />
          </div>
        </Section>
        <Section
            title={t('dashboard.text.3')}
            path="/statistics/sales"
          >
          <CampusSales semesterCode={res6?.data?.semesterCode} />
        </Section>
      </div>
      <div className='col-frame'>
        <Section title={t('dashboard.text.1')} path="/statistics/sales">
          <div className='board-chart-area bar-graph pt-5'>
            <ColumnChart data={res?.data ?? []} />
          </div>
        </Section>
        <Section title={t('class.dashboard.title7')}>
          <div className='board-chart-area board-anal__area'>
            <div className="d-flex flex-row h-100 align-items-center">
              <div className="w-50">
                {res4?.data && <HomepageVisitChart data={res4.data} />}
              </div>
              <div className="w-50">
                {res3?.data && <HomepageDeviceChart data={res3.data} />}
              </div>
            </div>
          </div>
        </Section>
      </div>
      <div className='col-frame'>
        <Section title={t('dashboard.text.2')} path="/statistics/sales">
          <div className='board-chart-area bar-graph pt-5'>
            <ColumnChart data={res2?.data ?? []} />
          </div>
        </Section>
        <Section title={t('class.dashboard.title8')}>
          <PageStats data={res5?.data} />
        </Section>
      </div>
    </div>
  );
};

export default HeadOffice;
